// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// Fetch link status for a specific customer
export const fetchCustomerLinkStatus = createAsyncThunk(
  'customerLinks/fetchStatus',
  async (customerId) => {
    const response = await axios.get(`/v1/customer-links/status/${customerId}`)
    return { customerId, status: response.data }
  }
)

// Fetch all customer link groups
export const fetchCustomerLinkGroups = createAsyncThunk(
  'customerLinks/fetchGroups',
  async () => {
    const response = await axios.get('/v1/customer-links')
    return response.data
  }
)

// Link a child customer to a primary
export const linkCustomer = createAsyncThunk(
  'customerLinks/link',
  async ({ primaryCustomerId, childCustomerId }) => {
    const response = await axios.post('/v1/customer-links', {
      primaryCustomerId,
      childCustomerId
    })
    return response.data
  }
)

// Unlink a customer
export const unlinkCustomer = createAsyncThunk(
  'customerLinks/unlink',
  async (linkId) => {
    await axios.delete(`/v1/customer-links/link/${linkId}`)
    return linkId
  }
)

export const customerLinksSlice = createSlice({
  name: 'customerLinks',
  initialState: {
    groups: [],
    currentCustomerStatus: null,
    isLoading: false,
    isLinking: false,
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearCurrentStatus: (state) => {
      state.currentCustomerStatus = null
    }
  },
  extraReducers: builder => {
    builder
      // Fetch status
      .addCase(fetchCustomerLinkStatus.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchCustomerLinkStatus.fulfilled, (state, action) => {
        state.currentCustomerStatus = action.payload.status
        state.isLoading = false
      })
      .addCase(fetchCustomerLinkStatus.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      // Fetch groups
      .addCase(fetchCustomerLinkGroups.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchCustomerLinkGroups.fulfilled, (state, action) => {
        state.groups = action.payload
        state.isLoading = false
      })
      .addCase(fetchCustomerLinkGroups.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      // Link customer
      .addCase(linkCustomer.pending, (state) => {
        state.isLinking = true
        state.error = null
      })
      .addCase(linkCustomer.fulfilled, (state) => {
        state.isLinking = false
      })
      .addCase(linkCustomer.rejected, (state, action) => {
        state.isLinking = false
        state.error = action.error.message
      })
      // Unlink customer
      .addCase(unlinkCustomer.pending, (state) => {
        state.isLinking = true
        state.error = null
      })
      .addCase(unlinkCustomer.fulfilled, (state) => {
        state.isLinking = false
      })
      .addCase(unlinkCustomer.rejected, (state, action) => {
        state.isLinking = false
        state.error = action.error.message
      })
  }
})

export const { clearError, clearCurrentStatus } = customerLinksSlice.actions

export default customerLinksSlice.reducer
